export const popupHeaderIcons = {
    add: 'icon-alan-plus-rounded',
    rename: 'icon-alan-edit-line',
    delete: 'icon-alan-trash',
    success: 'icon-alan-ok-fat'
};